import { defineMessages } from 'react-intl';

export default defineMessages({
  queryPlaceholderFiles: {
    id: 'frontbucket.repository.source.filter.queryPlaceholderFiles',
    description: 'Input placeholder text for filtering files',
    defaultMessage: 'Filter files',
  },
  queryPlaceholderCode: {
    id: 'frontbucket.repository.source.filter.queryPlaceholderCode',
    description: 'Input placeholder text for searching code',
    defaultMessage: 'Search for code',
  },
  moreFilesFound: {
    id: 'frontbucket.repository.source.filter.moreFilesFound',
    description: 'Message displayed when the filter has matched too many files',
    defaultMessage: `Showing the first {count, number} files. Refine your filter criteria for a complete list.`,
  },
  noFilesFound: {
    id: 'frontbucket.repository.source.filter.noFilesFound',
    description: 'Message displayed when the filter query matches no files',
    defaultMessage: `We didn't find any matching files. Update your filter criteria for better results.`,
  },
  errorFilteringFiles: {
    id: 'frontbucket.repository.source.filter.errorSearchingFiles',
    description: 'Message displayed when there is an error filtering files',
    defaultMessage: `There was an error filtering files. Please try again later.`,
  },
  unableToFilterFiles: {
    id: 'frontbucket.repository.source.filter.unableToFilterFiles',
    description:
      'Title displayed in a section message when the repository is too large to filter against all files',
    defaultMessage: 'Unable to filter all files',
  },
  unableToFilterFilesInfo: {
    id: 'frontbucket.repository.source.filter.unableToFilterFilesInfo',
    description:
      'Information displayed in a section message when the repository is too large to filter against all files',
    defaultMessage: `This repository is too large to display all the files. The filtered list is only displaying contents from the current directory.`,
  },
  stateMessage: {
    id: 'frontbucket.repository.source.filter.stateMessage',
    description: 'Message displayed when filtering files',
    defaultMessage: 'Filtering files in this repository...',
  },
  keyboardShortcutFilterFiles: {
    id: 'frontbucket.repository.source.filter.keyboardShortcutFilterFiles',
    description:
      'Description for the keyboard shortcut to focus the filter input',
    defaultMessage: 'Filter files in this repository',
  },

  keyboardShortcutCodeSearch: {
    id: 'frontbucket.repository.source.filter.keyboardShortcutCodeSearch',
    description:
      'Description for the keyboard shortcut to focus the filter input',
    defaultMessage: 'Search for code in this repository',
  },
  announceLimitedFiltering: {
    id: 'frontbucket.repository.source.filter.announceLimitedFiltering',
    description: 'Announce that limited count files displayed after filtering',
    defaultMessage:
      'Files have been filtered, the first {filterLimit} files were displayed. Refine your filter criteria for a complete list',
  },
  announceFiltering: {
    id: 'frontbucket.repository.source.filter.announceFiltering',
    description: 'Announce how many files were displayed after filtering',
    defaultMessage:
      'Files have been filtered, {filesCount, plural, =0 {no files} one {one file has} other {{filesCount} files have}} been displayed',
  },
});
